import { App } from 'vue';
import helperFilters from './filters/helpers.filters';

export default async function config(app: App): Promise<void> {
    helperFilters(app);
}
